__turbopack_context__.v({
  "age": "styles-module-scss-module__1ee-TW__age",
  "checkbox": "styles-module-scss-module__1ee-TW__checkbox",
  "checkmark": "styles-module-scss-module__1ee-TW__checkmark",
  "error": "styles-module-scss-module__1ee-TW__error",
  "inputContainer": "styles-module-scss-module__1ee-TW__inputContainer",
  "inputError": "styles-module-scss-module__1ee-TW__inputError",
  "inputPhone": "styles-module-scss-module__1ee-TW__inputPhone",
  "inputPhoneError": "styles-module-scss-module__1ee-TW__inputPhoneError",
  "line": "styles-module-scss-module__1ee-TW__line",
  "privacyPolice": "styles-module-scss-module__1ee-TW__privacyPolice",
  "root": "styles-module-scss-module__1ee-TW__root",
  "stackText": "styles-module-scss-module__1ee-TW__stackText",
  "submitContainer": "styles-module-scss-module__1ee-TW__submitContainer",
});
